<div class='error-content'>
  <h1>404</h1>
  <h2>Oops... S-a produs o eroare.</h2>
  <p>Din păcate, s-a produs o eroare. Încearcă mai târziu.</p>
  <button type='button' pButton
          [label]="'Întoarce-te la pagina principală'"
          (click)='goToFunds()'
          class='button-ipensii'></button>
</div>
